<template>
  <div class="rc-big-file-upload-desgin">
    <label class="item-name"><i class="required" v-show="initComponent.properties.required">*</i>{{initComponent.name}}</label>
    <i class="el-icon-upload"></i>
  </div>
</template>

<script>
import {componentMixin} from '../mixins'

export default {
  name: 'rc-big-file-upload',
  props: ['initComponent'],
  mixins: [componentMixin],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>

<style lang="scss">
  .rc-big-file-upload {
    .el-icon-upload {
      font-size: 35px;
      border: 1px solid #c2c3c4;
      border-radius: 4px;
      margin-top: 4px;
      color: #3a8ee6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/big-file-upload/rc-big-file-upload.vue